import e from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, h = ({ size: a = 16, useVw: o, useRem: t, color: c, withColor: l, removeClassName: n, disableSSR: g, style: i, ...m }) => {
  const p = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ e.createElement(x, { disableSSR: g }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "32px-gonggaozhongxin", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: o ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (t ? "rem" : "px"), height: o ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (t ? "rem" : "px"), className: n ? "" : "iconpark-icon", style: p, fill: "none", ...m }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: n ? "" : "32px-å¬åä¸­å¿"
    },
    /* @__PURE__ */ e.createElement(
      "g",
      {
        className: n ? "" : "normal",
        fill: l ? r(c, 0, "#262933") : "#262933",
        datafollowfill: l ? r(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M19.726 6.015c0-1.473-1.597-2.391-2.87-1.65l-6.91 4.02a2.308 2.308 0 0 1-1.158.311h-2.77A2.918 2.918 0 0 0 3.1 11.615v8.77a2.918 2.918 0 0 0 2.918 2.918h2.77c.407 0 .806.108 1.157.313l6.911 4.02c1.273.74 2.87-.178 2.87-1.65V6.014Zm-1.964-.095a.101.101 0 0 1 .054-.016c.016 0 .035.005.055.016.02.011.033.026.041.04a.1.1 0 0 1 .014.055v19.97a.1.1 0 0 1-.014.056.115.115 0 0 1-.041.039.115.115 0 0 1-.055.016.1.1 0 0 1-.054-.016l-6.912-4.02a4.103 4.103 0 0 0-2.062-.556h-2.77A1.119 1.119 0 0 1 4.9 20.385v-8.77c0-.618.5-1.119 1.118-1.119h2.77c.724 0 1.436-.191 2.062-.556l6.912-4.02Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M25.71 8.3a.9.9 0 1 0-1.272 1.273 9.09 9.09 0 0 1 0 12.855.9.9 0 1 0 1.273 1.273c4.253-4.253 4.253-11.148 0-15.401Z"
        }
      )
    )
  )));
}, s = h;
export {
  s as default
};
